<template>
  <CRow>

    <CCol sm="12">
      <CCard>

        <CCardHeader>
          <CIcon name="cil-object-group" />
          <h5 class="d-inline ml-2">Menu Groups</h5>
          <div class="card-header-actions">
            <CButton color="primary" :to="{ name: 'Add New Menu Group'}">
              <CIcon name="cil-plus" class="align-bottom" /><strong>Add New</strong> Menu Group
            </CButton>
          </div>
        </CCardHeader>

        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable-Sortable";

export default {
  name: "MenuGroups",
  components: {
    BackendTable,
  },
};
</script>
